import cn from "classnames";
import React, { ReactNode } from "react";
import { Col, Row } from "reactstrap";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import { LoadingSpinnerWembii } from "../../LoadingSpinnerWembii";
import { PanelWembii } from "../../PanelWembii";

interface Props {
  social: SocialProvider;
  children?: ReactNode;
  bindLoading?: boolean;
  removeShadow?: boolean;
  getLoading?: boolean;
  isSync: boolean;
  /** When set, uses an expanded layout with title + description (user settings integrations). */
  description?: ReactNode;
}

export default function SocialRow({
  social,
  children,
  bindLoading,
  removeShadow,
  getLoading,
  isSync,
  description,
}: Props) {
  const { id, name, email, icon, avatar, displayName, url } = social;

  const accountBlock = (
    <>
      <LoadingSpinnerWembii active={getLoading}>
        {avatar && (
          <img className="socialCard-avatar" src={avatar} alt="avatar" />
        )}
      </LoadingSpinnerWembii>
      <div className="ml-2">
        {displayName && <div className="truncate">{displayName}</div>}
        {url && (
          <div className="small truncate mb-2">
            <a href={url} target="_black">
              {url}
            </a>
          </div>
        )}
        {email && <div className="small truncate mb-2">{email}</div>}
      </div>
    </>
  );

  if (description) {
    return (
      <PanelWembii
        key={id}
        shadow={!removeShadow}
        className={cn(
          "integration-bind-row align-content-center border-0 justify-content-center px-3 py-3 text-left my-3"
        )}
      >
        <Row className="align-items-center">
          <Col
            xs="12"
            lg="2"
            className="d-flex justify-content-center justify-content-lg-start mb-3 mb-lg-0"
          >
            <div className="integration-bind-row__icon-wrap d-flex align-items-center justify-content-center h-100">
              {icon}
            </div>
          </Col>
          <Col xs="12" lg="6">
            <div className="integration-bind-row__body">
              <div className="font-weight-bold">{name}</div>
              <div className="small text-muted integration-bind-row__desc mt-1">
                {description}
              </div>
              {isSync && (
                <div className="d-flex align-items-center mt-3">{accountBlock}</div>
              )}
            </div>
          </Col>
          <Col xs="12" lg="4">
            <div className="integration-bind-row__actions d-flex align-items-center justify-content-center justify-content-lg-end mt-3 mt-lg-0 w-100">
              <LoadingSpinnerWembii active={bindLoading}>
                {children}
              </LoadingSpinnerWembii>
            </div>
          </Col>
        </Row>
      </PanelWembii>
    );
  }

  return (
    <PanelWembii
      key={id}
      shadow={!removeShadow}
      className="align-content-center border-0 justify-content-center px-3 py-2 text-center my-2"
    >
      <Row>
        <Col xs="12" lg="2">
          <div className="d-flex align-items-center h-100">{icon}</div>
        </Col>
        <Col xs="12" lg="5">
          <div className="d-flex align-items-center h-100">
            {!isSync ? (
              <span className="font-weight-bold">{name}</span>
            ) : (
              accountBlock
            )}
          </div>
        </Col>
        <Col xs="12" lg="5">
          <div className="d-flex align-items-center h-100">
            <LoadingSpinnerWembii active={bindLoading}>
              {children}
            </LoadingSpinnerWembii>
          </div>
        </Col>
      </Row>
    </PanelWembii>
  );
}
